// apps/client/src/ui/items/ItemDetail.tsx — the detail column of the pockets and storage screens: icon, name, stack size and
// what the shop pays. The screen passes the action buttons that apply as children.
import { getEntry } from '@whiskerton/content';
import type { ItemView } from '@whiskerton/shared';
import { sellPrice } from '@whiskerton/shared/rules/economy';
import type { ReactNode } from 'react';
import { useGame } from '../../state/store';
import { itemName, useT } from '../i18n';
import { useIcon } from './useIcon';

export function ItemDetail({ item, children }: { item: ItemView; children?: ReactNode }) {
  const t = useT();
  const town = useGame((s) => s.town);
  const entry = getEntry(item.catalogId);
  const icon = useIcon(item.catalogId);
  if (!entry || entry.kind === 'world') return null;
  const price = town ? sellPrice(item.catalogId, town) : 0;
  return (
    <div className="item-detail" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, textAlign: 'center' }}>
      <img src={icon} alt="" style={{ width: '12cqw', height: '12cqw', objectFit: 'contain' }} />
      <h3 style={{ margin: 0 }}>{itemName(entry.name)}</h3>
      {item.qty > 1 && <p style={{ margin: 0 }}>{t('items.qty', { n: item.qty })}</p>}
      <p style={{ margin: 0 }}>{price > 0 ? t('items.sellsFor', { price }) : t('items.noSale')}</p>
      <div style={{ display: 'grid', gap: 8, width: '100%' }}>{children}</div>
    </div>
  );
}
